export enum AccountType {
  SUPER_ADMIN = 'SUPER_ADMIN',
  DOCTOR = 'DOCTOR',
  ORGANIZATION = 'ORGANIZATION'
}